"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_TIMELINE_REQUEST_EXAMPLES = exports.getClinicalAuditTrailRequestSchema = exports.getPatientClinicalWorkflowTimelineRequestSchema = exports.getPatientClinicalTimelineRequestSchema = exports.clinicalAuditEntityTypeSchema = void 0;
/**
 * Request contracts for the 3 Clinical Timeline endpoints — all
 * read-only (GET), no `clinicalWorkflowExtrasShape` (no audit/
 * notification side effect exists on a pure read,
 * `CLINICAL-APPLICATION-REUSE.md` §8). `limit` is a bare optional
 * number, not `PaginationQuery` — `CLINICAL-CONTRACT-REUSE.md` §3
 * explains why. `entityType` mirrors `ClinicalAuditEntityType`
 * (`backend/src/modules/clinical/audit/clinical-audit.repository.ts`,
 * frozen, Stage 6C.1) exactly — all 11 values, not just the 6 that
 * `getPatientWorkflowTimeline` itself can produce, since
 * `getAuditTrail` is independently callable for any Clinical entity
 * type.
 */
const zod_1 = require("zod");
exports.clinicalAuditEntityTypeSchema = zod_1.z.enum([
    'Encounter',
    'ClinicalDocument',
    'ClinicalOrder',
    'ClinicalVitals',
    'ClinicalDiagnosis',
    'ClinicalProblemListEntry',
    'ClinicalAllergyListEntry',
    'ClinicalImmunizationHistory',
    'ClinicalCarePlan',
    'ClinicalTask',
    'ClinicalTemplate',
]);
exports.getPatientClinicalTimelineRequestSchema = zod_1.z.object({
    patientId: zod_1.z.string().uuid(),
    limit: zod_1.z.number().int().positive().max(500).optional(),
});
exports.getPatientClinicalWorkflowTimelineRequestSchema = exports.getPatientClinicalTimelineRequestSchema;
exports.getClinicalAuditTrailRequestSchema = zod_1.z.object({
    entityType: exports.clinicalAuditEntityTypeSchema,
    entityId: zod_1.z.string().uuid(),
});
exports.CLINICAL_TIMELINE_REQUEST_EXAMPLES = {
    getPatientClinicalTimeline: {
        patientId: '11111111-1111-1111-1111-111111111111',
        limit: 20,
    },
    getPatientClinicalWorkflowTimeline: {
        patientId: '11111111-1111-1111-1111-111111111111',
        limit: 20,
    },
    getClinicalAuditTrail: {
        entityType: 'ClinicalDocument',
        entityId: '88888888-8888-8888-8888-888888888888',
    },
};
//# sourceMappingURL=clinical-timeline.request.js.map